/** 破损面单查询 - 面单字段对照示例图（静态资源，见 public/damaged-label-lookup/） */
const DAMAGED_LABEL_EXAMPLE_BASE_PATH = `${process.env.PUBLIC_URL}/damaged-label-lookup`;

const DAMAGED_LABEL_EXAMPLE_FILE_BY_LANG: Record<string, string> = {
    zh: 'label-field-example.zh.png',
    en: 'label-field-example.en.png',
    es: 'label-field-example.es.png',
};

const DAMAGED_LABEL_EXAMPLE_FALLBACK_LANG = 'en';

/** 按界面语言解析示例图 URL；未知语言回退英文 */
export function getDamagedLabelFieldExampleImageUrl(language: string | undefined): string {
    const lang = (language ?? DAMAGED_LABEL_EXAMPLE_FALLBACK_LANG).toLowerCase().split('-')[0];
    const file =
        DAMAGED_LABEL_EXAMPLE_FILE_BY_LANG[lang] ??
        DAMAGED_LABEL_EXAMPLE_FILE_BY_LANG[DAMAGED_LABEL_EXAMPLE_FALLBACK_LANG];
    return `${DAMAGED_LABEL_EXAMPLE_BASE_PATH}/${file}`;
}
